import styled from "styled-components";

export const StyledFloatingCloseButton = styled.button`
  align-items: center;
  background: var(--rms-v2-surface);
  border: 0;
  border-radius: 50%;
  box-shadow: 0 8px 18px rgba(16, 24, 40, 0.18);
  color: var(--rms-v2-text-muted);
  cursor: pointer;
  display: inline-flex;
  height: 36px;
  justify-content: center;
  padding: 0;
  position: absolute;
  left: 50%;
  top: -50px;
  transform: translateX(-50%);
  width: 36px;
  z-index: 4;

  svg {
    height: ${(props) => props.iconSize}px;
    stroke: currentColor;
    width: ${(props) => props.iconSize}px;
  }
`;
